import React, {Component} from 'react';

export default class Result extends Component {
    render() {
        var ignoredResult;
        // if (this.props.ignoreHolidays) {
        //   ignoredResult = this.props.resultDate.replace("<date_placeholder>", this.props.date);
        // }
        return (
            <div className="result-information">
                <span className="result-title">Resultat</span>
                {this.props.result !== "" ?
                    <span className="result-information-text" dangerouslySetInnerHTML={{__html: this.props.result}}/> :
                    null}
                {this.props.date2 !== undefined ?
                    <div>
            <span className="result-information-result-text">
              {this.props.resultDate}
            </span>
                        <span className="result-information-date">
              {this.props.date}
            </span>
                        <span className="result-information-result-text">
              {this.props.resultDate2}
            </span>
                        <span className="result-information-date">
              {this.props.date2}
            </span>
                    </div>
                    :
                    <div>
            <span className="result-information-date">
              {this.props.date}
            </span>
                        <span className="result-information-result-text">
              {this.props.resultDate}
            </span>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Result.js